/*
 * Código del server (spec fase 3 §3.4) → texto. hosting no tiene catálogo de
 * i18n de dominio (los textos van inline en español), así que aquí viven los
 * mismos mensajes que levita-front usa en src/app/locales/es-LA.js.
 */
export const TEXTO_POR_CODIGO = {
  INVALID_CREDENTIALS: 'Correo, contraseña o equipo incorrectos',
  TOO_MANY_ATTEMPTS: 'Demasiados intentos, espera {minutes} minutos',
  SERVER_BUSY: 'El servidor está ocupado, intenta en unos segundos',
  MFA_INVALID_CODE: 'Código incorrecto',
  MFA_INVALID_CODE_LOGIN: 'Código incorrecto, vuelve a iniciar sesión',
  MFA_LOCKED: 'Demasiados códigos incorrectos, espera {minutes} minutos',
  CHALLENGE_INVALID: 'La verificación caducó, vuelve a iniciar sesión',
  MFA_REQUIRED: 'Tu cuenta tiene verificación en dos pasos; captura el código',
  MFA_UNAVAILABLE: 'No se pudo verificar el código, intenta más tarde',
  MFA_ALREADY_ACTIVE: 'Ya tienes la verificación en dos pasos activa',
  MFA_NOT_PENDING:
    'No hay un enrolamiento pendiente; genera un código QR nuevo',
  TOKEN_EXPIRED: 'Tu sesión expiró, vuelve a iniciar sesión',
  SESSION_REVOKED_NEW_DEVICE:
    'Tu sesión se cerró porque iniciaste sesión en otro dispositivo',
  SESSION_EXPIRED: 'Tu sesión expiró, vuelve a iniciar sesión',
  SESSION_REVOKED: 'Tu sesión se cerró',
  SESSION_UNAVAILABLE:
    'El servicio de sesiones no está disponible, intenta de nuevo',
  REFRESH_INVALID: 'Tu sesión expiró, vuelve a iniciar sesión',
  FORBIDDEN: 'No tienes autoridad para esta acción',
  NETWORK: 'No hay conexión con el servidor, intenta de nuevo',
  GENERIC: 'Ocurrió un error al autenticar, intenta de nuevo',
};

export function mensajeDeAuth(error, contexto = 'login') {
  const { code, message, retryAfterMinutes } = error || {};
  if (code === 'BLACKLISTED' && message) return message;
  let clave = TEXTO_POR_CODIGO[code] ? code : 'GENERIC';
  if (code === 'MFA_INVALID_CODE' && contexto === 'login')
    clave = 'MFA_INVALID_CODE_LOGIN';
  const texto = TEXTO_POR_CODIGO[clave];
  if (code === 'TOO_MANY_ATTEMPTS' || code === 'MFA_LOCKED') {
    return texto.replace('{minutes}', String(retryAfterMinutes ?? 15));
  }
  return texto;
}

// Los AuthError de authClient no se le pasan enteros a mensajeDeAuth: su
// `.message` cae al `code` cuando el server no mandó texto, así que BLACKLISTED
// acabaría mostrando la palabra "BLACKLISTED". Este ayudante saca del error lo
// que el server sí dijo (`serverMessage`) y el resto de los datos del catálogo.
// Lo usan enrolar/index.js y `rechazo()` en store/slices/authSlice.js.
export function mensajeDeError(err, contexto = 'login') {
  return mensajeDeAuth(
    {
      code: err && err.code,
      message: err && err.serverMessage,
      retryAfterMinutes: err && err.retryAfterMinutes,
    },
    contexto
  );
}
